"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcBreadcrumbV2Constants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcBreadcrumbV2Constants = (function () {
    function BcBreadcrumbV2Constants() {
    }
    var _a;
    _a = BcBreadcrumbV2Constants;
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-breadcrumb-v2");
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEMS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-breadcrumb-v2-items");
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_OPTIONS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-float-menu-option");
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM = 'item';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM_MENU_CLASS = 'item-menu';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-breadcrumb-v2-overflow");
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP = 'bc-tooltip';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_TEXT_ATTRIBUTE = 'bcTooltipText';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION_ATTRIBUTE = 'bcTooltipPosition';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION = 'bottom';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ANGLE_RIGHT_ICON = 'angle-right';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_MOBILE_WIDTH = 767;
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_SPAN_WIDTH = 232;
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOTAL_ITEMS = 6;
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_BUTTON_READER = 'Más opciones';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_REDRAW_TIMER = 40;
    BcBreadcrumbV2Constants.Bc_BREADCRUMB_V2_DATA_ATTRIBUTE = 'data-breadcrumb-items';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_BC_LINK = 'bc-link';
    BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_LINK_DEFAULT = 'link-default';
    BcBreadcrumbV2Constants.BC_FLOAT_MENU = 'bc-float-menu';
    BcBreadcrumbV2Constants.BC_FLOAT_MENU_CONTENT = "".concat(_a.BC_FLOAT_MENU, "-content");
    BcBreadcrumbV2Constants.BC_FLOAT_MENU_ARROW = "".concat(_a.BC_FLOAT_MENU, "-arrow");
    BcBreadcrumbV2Constants.BC_FLOAT_MENU_ARROW_CENTER = "".concat(_a.BC_FLOAT_MENU, "-arrow-center");
    BcBreadcrumbV2Constants.BC_FLOAT_MENU_TOGGLE = "".concat(_a.BC_FLOAT_MENU, "-toggle");
    BcBreadcrumbV2Constants.BC_ICON_MENU_DOTS = 'menu-dots-v';
    BcBreadcrumbV2Constants.BC_ICON = 'bc-icon';
    BcBreadcrumbV2Constants.BC_ICON_BUTTON = "".concat(_a.BC_ICON, "-button");
    BcBreadcrumbV2Constants.BC_ICON_BUTTON_GHOST = "".concat(_a.BC_ICON, "-button-ghost");
    BcBreadcrumbV2Constants.BC_ICON_BUTTON_SMALL = "".concat(_a.BC_ICON, "-button-small");
    return BcBreadcrumbV2Constants;
}());
exports.BcBreadcrumbV2Constants = BcBreadcrumbV2Constants;
